import type { FooterSocialButton, FooterLink } from '../CardShell';

export const defaultFooterSocialButtons: FooterSocialButton[] = [
  { icon: 'facebook', onClick: () => window.open('https://www.facebook.com/sprakservice', '_blank'), color: '#070243' },
  { icon: 'linkedin', onClick: () => window.open('https://se.linkedin.com/company/spr-kservice-sverige-ab', '_blank'), color: '#070243' },
  { icon: 'instagram', onClick: () => window.open('https://www.instagram.com/sprakservicesverigeab/', '_blank'), color: '#070243' },
];

export const defaultFooterLinks: FooterLink[] = [
  { label: 'Integritetspolicy', onClick: () => window.open('https://www.sprakservice.se/integritetspolicy', '_blank') },
  { label: 'Cookies', onClick: () => window.open('https://www.sprakservice.se/cookiepolicy', '_blank') },
  { label: 'Copyright © Språkservice Sverige AB' },
];
